import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import moment from 'moment';
import { getCertificateAsync } from '../../../Services/CertificateService';
import { DATE_FORMAT } from '../../../Infrastructure/Config/DateConfig';
import TSALogo from '../../../Assets/TSALogo.png';

// Public, shareable proof of completion (linked from LinkedIn and the completion email).
// :id is the learner-course (tracking) id. Replaces the credential page Accreditise provided.
const VerifyCertificate = () => {
    const { id } = useParams();
    const [certificate, setCertificate] = useState(null);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        getCertificateAsync(id)
            .then(result => {
                setCertificate(result);
                setStatus(result ? 'found' : 'not-found');
            })
            .catch(err => {
                console.error(err);
                setStatus('error');
            });
    }, [id]);

    return (
        <div className="container">
            <div className="row mt-5">
                <div className="col-sm-10 offset-sm-1 col-md-6 offset-md-3 text-center my-5 shadow p-5 bg-white">
                    <img alt="The Sustainability Academy" className="img-fluid mb-4" src={TSALogo} style={{ maxWidth: '240px' }} />

                    {status === 'loading' && (
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    )}

                    {status === 'found' && (
                        <>
                            {certificate.badgeImageUrl && (
                                <img alt={certificate.courseTitle} className="img-fluid mb-4" src={certificate.badgeImageUrl} style={{ maxWidth: '180px' }} />
                            )}
                            <p className="text-success mb-3"><strong>✓ Verified certificate of completion</strong></p>
                            <h4 className="mb-1">{`${certificate.firstName || ''} ${certificate.lastName || ''}`.trim()}</h4>
                            <p className="mb-1">successfully completed</p>
                            <h4 className="mb-1">{certificate.courseTitle}</h4>
                            <p className="mb-0">on {moment(certificate.completedDate).format(DATE_FORMAT)}</p>
                        </>
                    )}

                    {status === 'not-found' && (
                        <p className="mb-0">This certificate couldn't be found. Please check the link.</p>
                    )}

                    {status === 'error' && (
                        <p className="mb-0">Something went wrong checking this certificate. Please try again later.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyCertificate;
